export const getSelectorStyles = (errorMessage?: string) => {
    return {
        multiValue: (provided: any, state: any) => ({
            ...provided,
            backgroundColor: '#EDE7FE'
        }),
        control: (provided: any, state: any) => ({
            ...provided,
            cursor: state.isDisabled ? "not-allowed" : "pointer",
            borderColor: errorMessage ? "var(--error-red)" : "#A0A2A5",
            borderRadius: "8px",
            minHeight: "48px",
            marginTop: "8px",
            outline: 'none',
            boxShadow: 'none',
            backgroundColor: "none",

            "&:hover": {
                borderColor: errorMessage ? "var(--error-red)" : "#A0A2A5",
            }
        }),
        singleValue: (provided: any, state: any) => ({
            ...provided,
            cursor: state.isDisabled ? "not-allowed" : "pointer",
            color: state.isDisabled ? "var(--text-disabled)" : "var(--text-black)",
            fontSize: "16px",
            fontWeight: 400,

        }),
        indicatorSeparator: (provided: any, state: any) => ({
            ...provided,
            backgroundColor: 'transparent',
        }),
        dropdownIndicator: (provided: any, state: any) => ({
            ...provided,
            color: '#A0A2A5',
            cursor: 'pointer',
            transform: state.selectProps.menuIsOpen ? "rotate(180deg)" : "rotate(0deg)",
            transitionDuration: "300ms",
            transitionProperty: "transform",
            pointerEvents: 'none',
            "&:hover": {
                color: '#A0A2A5',
            }
        }),
        option: (provided: any, state: any) => ({
            ...provided,
            fontSize: 16,
            cursor: state.isDisabled ? "not-allowed" : "pointer",
            backgroundColor: state.isSelected ? 'var(--gold)' : state.isFocused ? 'var(--light-gold)' : 'var(--white)',
            color: 'var(--text-black)',
            '&:hover': {
                fontSize: 16,
                backgroundColor: state.isSelected ? 'var(--gold)' : state.isFocused ? 'var(--light-gold)' : 'var(--white)',
                color: 'var(--text-black)',
            }
        })
    }
}
